import { CostType } from '../enums';

type InvoiceItemLabelForCostType = { [key in CostType]: string };

export function getInvoiceItemLabelForDeduction(costType: CostType): string {
  return `Gutschrift ${INVOICE_ITEM_LABEL[costType]}`;
}

export const INVOICE_ITEM_LABEL: InvoiceItemLabelForCostType = {
  [CostType.CARE]: 'Pflegebedingte Aufwendungen',
  [CostType.ACCOMMODATION]: 'Unterkunftskosten',
  [CostType.LODGING]: 'Verpflegungskosten',
  [CostType.INVESTMENT]: 'Investitionskosten',
  [CostType.SURCHARGE_43B]: 'Vergütungszuschlag nach § 43b SGB XI',
  [CostType.SURCHARGE_84_9]: '§ 132g Abs. 3 SGB V',
  [CostType.TRAINING_LEVY]: 'Ausbildungsumlage',
  [CostType.CARE_AIDS]: 'Pflege-Hilfsmittel',
  [CostType.TRAVEL_EXPENSES]: 'Reisekosten',
  [CostType.OPTIONAL_SERVICE]: 'Wahlleistung',
  [CostType.OTHER]: 'Andere Kosten',
};
